/**
 * Branding (ver BRANDING.md): troca a palavra "Chatwoot" pelo INSTALLATION_NAME
 * nos textos da interface.
 * - Só a palavra com inicial maiúscula é trocada, para não alterar URLs
 *   (app.chatwoot.com) nem identificadores (window.chatwootSettings, {latestChatwootVersion}).
 * - Se o nome for feminino (name_gender em config/branding.yml), corrige as
 *   contrações do português: "no/do/pelo/ao/o Chatwoot" -> "na/da/pela/à/a <nome>".
 */
const BRAND_WORD = /\bChatwoot\b/g;
const NOT_AFTER_LETTER = '(?<!\\p{L})';

const FEMININE_RULES = [
  [new RegExp(`${NOT_AFTER_LETTER}([DdNn])o Chatwoot\\b`, 'gu'), l => `${l}a`],
  [
    new RegExp(`${NOT_AFTER_LETTER}([Pp])elo Chatwoot\\b`, 'gu'),
    l => `${l}ela`,
  ],
  [new RegExp(`${NOT_AFTER_LETTER}(A)o Chatwoot\\b`, 'gu'), () => 'À'],
  [new RegExp(`${NOT_AFTER_LETTER}(a)o Chatwoot\\b`, 'gu'), () => 'à'],
  [
    new RegExp(`${NOT_AFTER_LETTER}([Oo]) Chatwoot\\b`, 'gu'),
    l => (l === 'O' ? 'A' : 'a'),
  ],
];

const isFeminine = () => window.brandingConfig?.nameGender === 'feminino';

export const brandText = (text, name, { feminine = isFeminine() } = {}) => {
  if (typeof text !== 'string' || !name) return text;
  let result = text;
  if (feminine) {
    FEMININE_RULES.forEach(([pattern, article]) => {
      result = result.replace(
        pattern,
        (_, letter) => `${article(letter)} ${name}`
      );
    });
  }
  return result.replace(BRAND_WORD, () => name);
};

const replaceDeep = (value, name, feminine) => {
  if (typeof value === 'string') return brandText(value, name, { feminine });
  if (Array.isArray(value)) {
    return value.map(item => replaceDeep(item, name, feminine));
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        replaceDeep(item, name, feminine),
      ])
    );
  }
  return value;
};

// Aplica a troca em todas as mensagens de i18n ao criar o app; contrações só nos idiomas pt*.
export const brandMessages = messages => {
  const name = window.globalConfig?.INSTALLATION_NAME;
  if (!name || name === 'Chatwoot') return messages;
  const feminine = isFeminine();
  return Object.fromEntries(
    Object.entries(messages).map(([locale, localeMessages]) => [
      locale,
      replaceDeep(localeMessages, name, feminine && locale.startsWith('pt')),
    ])
  );
};
